import React, { ReactElement } from 'react'
import { ALERT_MESSAGES } from '../../enums/common'

interface ErrorMessage {
  errorMessage: string
}

function ErrorMessage({ errorMessage }: ErrorMessage): ReactElement {
  return (
    <span className="errorMessage">
      {errorMessage || ALERT_MESSAGES.mandatory.message}
    </span>
  )
}

export default ErrorMessage
